import { OptimizelyFlags, useOptimizelyDecisionTimedOut } from '@/services/experiments';

const ENABLED_VARIATION_KEY = 'enabled';
const ON_VARIATION_KEY = 'on';
const DEFAULT_ENABLED_VARIATION_KEYS = [ENABLED_VARIATION_KEY, ON_VARIATION_KEY];

export const useAiImageOptimization = (): { isEnabled: boolean; isLoading: boolean } => {
  const { isLoaded, decision } = useOptimizelyDecisionTimedOut(
    OptimizelyFlags.AI_POWERED_IMAGE_OPTIMIZATION,
    true,
    1000, // 1 second timeout
  );

  const isEnabled =
    decision && decision.variationKey
      ? DEFAULT_ENABLED_VARIATION_KEYS.includes(decision.variationKey)
      : false;

  return {
    isEnabled,
    isLoading: !isLoaded,
  };
};
